import { render } from "./Test.vue?vue&type=template&id=41a3c9f4&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-41a3c9f4"

export default script